import EmptyViewViewModel from '@/ViewModels/Views/EmptyViewViewModel';
import layout from './EmptyView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';

export default class EmptyView extends View {
    private view: JQuery<HTMLElement>;
    
    constructor(private viewModel: EmptyViewViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('EmptyView', EmptyView, 'RADPresentation.HTMLClient.DefaultViewExtensions');